import { render, staticRenderFns } from "./CoViewPublicEvent.vue?vue&type=template&id=77a088f9&"
import script from "./CoViewPublicEvent.vue?vue&type=script&lang=js&"
export * from "./CoViewPublicEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports